/// <amd-module name="Agile/Directory/Redux/DirectoryModule" />
import { IDirectoryArtifact, IDirectoryAwareState } from "Agile/Directory/DirectoryContracts";
import { artifactReducer } from "Agile/Directory/Redux/Artifacts/ArtifactReducer";
import { directorySaga } from "Agile/Directory/Redux/DirectorySaga";
import { favoritesReducer } from "Agile/Directory/Redux/Favorites/FavoritesReducer";
import { directoryUIStateReducer } from "Agile/Directory/Redux/UIState/DirectoryUIStateReducer";
import { combineReducers } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

export const DirectoryModule: ISagaModule<IDirectoryAwareState<IDirectoryArtifact>> = {
    id: "directory",

    // @ts-ignore TypeScript 3.5 update
    reducerMap: {
        directoryState: combineReducers({
            directoryArtifactState: artifactReducer,
            favoriteState: favoritesReducer,
            uiState: directoryUIStateReducer
        }) as any
    },
    sagas: [directorySaga]
};
